.shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 3.75rem;
  background:
    radial-gradient(circle at top left, var(--color-glow-left) 0%, transparent 38%),
    radial-gradient(circle at top right, var(--color-glow-right) 0%, transparent 32%),
    var(--color-bg);
  transition: background-color 180ms ease;
}

.main {
  width: min(1400px, calc(100% - 2rem));
  margin: 0 auto;
  padding: 2rem 0 3rem;
  flex: 1;
}
